<template>
  <div class="cmp-catalog-releases-releases_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img @click="onAddReleasesClick" class="dt-icon v5 s1" src="static/buttons/add.svg" alt />
        </div>
      </div>
      <div class="search" style="max-width: 350px">
        <InputField :value="searchString" :placeholder="$t('search')" :config="{
          borderStyle: 'bottom',
          width: '200px',
          minWidth: '200px',
          maxWidth: '200px',
        }" @keyup="onSearchInputKeyup"></InputField>
        <DTIconButton :classNames="'search--advanced'" :text="$t('advanced_search')" :style="{
          minWidth: '148px',
          maxWidth: '148px',
        }" icon="add-blue" @click="onAdvancedSearchClick" />
      </div>
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge v-for="sconKey of filteredAdvancedSearchConfigKeys" :key="sconKey"
            v-bind="searchConfigKey(sconKey)" @delete="onSearchConDelete" />
        </div>
      </div>
      <div class="right-container ut-colcen">
        <div class="ut-flex">
          <button class="dt-button v7 s8" :class="{
            active:
              searchType == 'release_standard_search' || searchType == 'none',
          }" @click="(e) => onFilterButtonClicked('release_standard_search')">
            {{ $t("standard") }}
          </button>
          <button class="dt-button v7 s8" :class="{
            active: searchType == 'release_weekly_search',
          }" @click="(e) => onFilterButtonClicked('release_weekly_search')">
            {{ $t("weekly") }}
          </button>
          <button class="dt-button v7 s8" :class="{
            active: searchType == 'release_monthly_search',
          }" @click="(e) => onFilterButtonClicked('release_monthly_search')">
            {{ $dft.capHead($t("monthly")) }}
          </button>
          <div id="LabelReleasesTab">

          </div>
          <button class="dt-button v5 s8" @click="onExport">
            {{ $t("Release Export") }}
          </button>
        </div>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable id="catalog-releases-releases_list" class="h1" :config="tableConfig" :headers="contactHeaders"
        :items="list" :loadingFlag="loadingFlag" @scrollnext="onReleasesNext">
        <template v-slot:item="{ item, tdcon }">
          <tr @click="onReleaseClicked(item)">
            <td :title="item['release_title']" v-bind="tdcon('releases')">
              <div class="ut-flex">
                <DtStatus :statusTVList="statusTVList" :item="getItemForStatus(item)" @updateStatus="onStatusChange" />
                <div style="font-weight: bold;margin-left:3px">
                  <b>{{ item["release_title"] }}</b>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('artist_filter')">
              <span style="font-weight: bold"><b>{{ item["release_artist"] }}</b></span>
            </td>
            <td v-bind="tdcon('release_date')">
              <span>{{ item["release_date"] }}</span>
            </td>
            <td v-bind="tdcon('function')">
              <span>{{ item["release_type"] }}</span>
            </td>
            <td v-bind="tdcon('contract_key')">
              <span>{{ item["contract_key"] }}</span>
            </td>

            <td v-bind="tdcon('release_code')">
              <span>{{ item["identifier"] }}</span>
            </td>
            <td :title="item['catalog_list']" v-bind="tdcon('release_catalog_no')">
              <span>{{ item["catalog_list"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div style="display:flex" >
                <div class="actions">
                  <img @click.stop="(e) => onClickRelease(item)" src="static/icons/mechanical-contract.svg" class="dt-icon v5 s2" alt
                  :title="`${$t('report')}`" />
                </div>
               
              <img v-if="item.total_cost_splits <= 0 && item.total_product <= 0" src="static/icons/delete.svg"
                @click.stop="(e) => onReleaseDelete(item)" class="dt-icon v5 s2 ut-center" alt />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <DtPageStatusFloat :statusTV="statusTV" />

    <Sidewindow :navConfig="defaultConfig" :value="releaseDetailsFlag" @closed="onCloseReleaseDetails">
      <ReleaseSidewindow @closed="onCloseReleaseDetails" />
    </Sidewindow>

    <ModalContainer :modalKey="'createReleases'" :width="'420'">
      <CreateReleases @addRelease="addRelease" v-if="releasesCatalogData" :labels="labels" :statuses="statuses"
        @cancelled="closeModal" />
    </ModalContainer>
    <ModalContainer :modalKey="'proAgency'" :width="'420'">
      <ProAgency @cancelled="closeModal" />
    </ModalContainer>

    <ModalContainer :modalKey="'advanceSearch'" :width="'420'">
      <AdvanceSearch v-if="releasesCatalogData" :initSearchFilter="searchFilter"
        :advancedSearchData="advancedSearchData" :loading="releaseCatalogMetaData &&
          releaseCatalogMetaData.releaseCatalogMetaDataLoading
          " @search="onAdvancedSearch" @create_group="onAdvancedSearchCreateGroup"
        @cancelled="onAdvancedSearchCancelled" />
    </ModalContainer>

    <ModalContainer :modalKey="'releaseExport'" :width="'420'">
      <ReleaseExportModal @cancelled="closeModal" />
    </ModalContainer>

    <ModalContainer :modalKey="'deactiveRelease'" :width="'350'">
      <ReleaseStatusDeactivateModal @cancelled="closeModal" />
    </ModalContainer>






  </div>
</template>

<script>
import { CatalogStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

//import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
  closeModal2Route,
} from "@/dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import CreateReleases from "./create-releases";
import AdvanceSearch from "./advance-search";
import ProAgency from "./pro-agency.vue";
import ReleaseSidewindow from "./releases-sidewindow";
import { releaseService } from "../../services/releases/releases.services";

import {
  getReleasesDetailsSelectable,
  releasesListLDTRoutes,
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";
import { subscribeSubject, subscribeSubjectND } from "../../../../utility";

import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
const LDTConfig = {
  entityName: "release",
  ldtRoutes: releasesListLDTRoutes,
  detailsSelectableFunction: getReleasesDetailsSelectable,
  primaryKey: "release_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ReleaseDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ReleaseDetails.FETCH.SINGLE,
};

import { createTV, tv } from "../../../../models/text-value.model";
import { releasesCatalogActions } from "../../store/releases/actions";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { releasesCatalogGetters } from "../../store/releases/getters";
import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
import ReleaseExportModal from "./release-export-modal.vue";
import DtPageStatus from "@dtplugins/dtpage-status/dtpage-status";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import DtStatus from "@dtplugins/dt-status-dropdown/dt-status"
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import ReleaseStatusDeactivateModal from "./release-status-deactivate-modal.vue";
import { baseUrl, clientName } from "../../../../services/http/http-client";
export const releaseListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "artist",
    "title",
    "start_date",
    "end_date",
    "identifier",
    "release_status",
    "label_id",
    "release_type",
  ],
  searchConfigTVMap: [
    ["label_id", "labelsTV"],
    ["release_type", "releaseTypeTV"],
    ["release_status", "releaseStatusesTV"],
  ],
  // booleanSearchKeyLabelMap: {
  //   barcode_catalog_error: "Barcode Error",
  // },
});

export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    CreateReleases,
    AdvanceSearch,
    ReleaseSidewindow,
    ReleaseExportModal,
    DtPageStatus,
    DtPageStatusFloat,
    DtStatus,
    ProAgency,
    ReleaseStatusDeactivateModal
  },
  mounted: function () {
    //this.fetchData();
    this.fetchListReset();
    this[ActionTypes.ReleasesCatalogData.FETCH.ALL]();
    subscribeSubject(this, this.subjectSearchSubject, (searchString) => {
      console.log("STRING SER", searchString);

      releaseService.filterReleases(searchString).then((res) => {
        console.warn("WWWW", searchString, res);
        this.searchResult = res.data.releases;
        //this.genreSearchResult=res.data.unrelated_genres
      });
    });

    subscribeSubjectND(this, this.scrollSubject$, (scrollTop) => {
      if (this.start == this.loadedStart) {
        this.start += this.row_count;
        this.fetchListNext();
      }
    });
  },
  data: function () {
    return {
      startRow: 0,
      subjectSearchSubject: new Subject(),
      searchResult: [],
      start: 0,
      row_count: 100,
      loadedStart: 0,
      loadedEnd: false,
      searchString: "",
      defaultConfig: defaultConfig,
      scrollSubject$: new Subject(),
      searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search

      loadingFlag: false,
    };
  },
  mixins: [
    createLDTHost(LDTConfig),
    createModalMixin("createReleases"),
    createModalMixin("advanceSearch"),
    createModalMixin("proAgency"),
    createModalMixin("releaseExport"),
    createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
      onBeforeAdvancedSearchFetch: "onBeforeAdvancedSearchFetch",
    }),
    createModalMixin("deactiveRelease")
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) { },
    },
  },
  computed: {
    // ...mapGetters(storeNS, {
    //   releasesCatalogData: "releasesCatalogData",

    // }),
    ...mapGetterObject(storeNS, releasesCatalogGetters),

    statusTV: function () {
      return (
        this.releasesCatalogData?.status?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"]
              ? e["label_status_colour"]
              : "000000",
          };
        }) || []
      );
    },
    statusTVList: function () {
      return (
        this.releasesCatalogData?.status?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"]
              ? e["label_status_colour"]
              : "000000",
            id: e["label_status_id"],
          };
        }) || []
      );
    },
    advancedSearchData: function () {
      return {
        labelsTV: createTV(this.labels, "label_name", "label_id"),

        releaseStatusesTV: createTV(
          this.statuses,
          "label_status_name",
          "label_status_id"
        ),

        releaseTypeTV:
          this.releasesCatalogData?.release_types?.map((e) => {
            return {
              text: this.$t(e["textkey"]),
              value: e["value"],
            };
          }) || [],

        // [
        //     { text:'Album' ,value:'album' },
        //     { text:'Single' ,value:'single' },
        //     { text:'EP' ,value:'ep' },
        //     { text:'Compilation' ,value:'compilation' },
        //     { text:'Merchandise' ,value:'merchandise' },
        //     { text:'Promo' ,value:'promo' }

        //   ]
      };
    },

    releaseDetailsFlag: function () {
      return childOfOrEqualDetails(releasesListLDTRoutes, this.$route);
    },

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      if (this.releasesCatalogData && this.searchString.length == 0) {
        return this.releasesCatalogData.releases;
      } else {
        return this.searchResult;
      }
      return [];
    },
    statuses: function () {
      if (this.releasesCatalogData) {
        return this.releasesCatalogData.status;
      }
      return [];
    },
    labels: function () {
      //console.log('this.releasesCatalogData', this.releasesCatalogData);
      return this.releaseCatalogMetaData?.labels || [];
    },
    // list: function () {
    //   return this.searchString.length
    //     ? this.contactFilesSearchResult
    //     : this.contactFiles;
    // },
    contactHeaders: function () {
      return [
        createTableHeader("releases", { f: 1.2 }),
        createTableHeader("artist_filter", { f: 0.9 }),
        createTableHeader("release_date", { f: 0.5 }),
        createTableHeader("function", { f: 0.6 }),
        createTableHeader("contract_key", { f: 0.6 }),
        createTableHeader("release_code", { text: 'release_code', f: 0.5 }),
        createTableHeader("release_catalog_no", {
          text: 'release_catalog_no',
          f: 1.5,
        }),
        createTableHeader("options", { text: false, mw: 80 }),
      ];
    },
    filter: function () {
      const no_filter_selected = Object.values(this.searchFilter)?.every(
        (e) => !e
      );

      let searchType = this.searchType;
      if (!no_filter_selected && this.searchType == "none") {
        searchType = "release_standard_search";
      }

      return {
        searchType,
        no_filter_selected,

        str: this.searchString,

        start: this.start,
        row_count: this.row_count,

        ...this.searchFilter,
        // barCodeCatalogError: this.barCodeCatalogError ? 1 : 0,
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, releasesCatalogActions),
    getItemForStatus: function (item) {

      return {
        itemID: item.release_id,
        colorPropertyName: 'label_status_id',
        colorPropertyValue: item.label_status_id,
        colorName: 'label_status_colour',
        colorValue: item.label_status_colour,
      };
    },
    onContactFilesNext: function (scrollPercent) {
      if (this.searchString.length == 0) {
        this.fetchNext();
      }
    },
    fetchData: function () {
      this[ActionTypes.ReleaseList.FETCH.ALL]({});
    },
    searchContactFiles: function (key) {
      this[ActionTypes.ContactFilesSearchResult.FETCH.ALL](key);
    },

    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;

      this.subjectSearchSubject.next(this.searchString);
    },
    onAddReleasesClick: function () {
      console.log("WEEEEEEEEEEE");

      this.$router.push({
        ...this.$route,
        query: {
          modal: "create_releases",
        },
      });
    },
    addRelease: async function (payload) {
      console.log(payload);
      const ReleaseId = await this[ActionTypes.ReleaseList.INSERT.SINGLE](
        payload
      );
      closeModalRoute(this);

      console.log(ReleaseId);

      this.$router.push({
        name: releasesListLDTRoutes.names.tab,
        params: {
          release_id: ReleaseId,
          tab: "overview",
        },
      });
    },
    onAddProAgency: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "pro_agency",
        },
      });
    },
    onClickRelease: function (item) {

      const url = `${baseUrl}/${clientName}/distribution.pl?section=reports&action=release_report&release_id=${item.release_id}`
      console.log("::::::", url)

      window.open(url);
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advance_search",
        },
      });
    },
    onReleasesNext: function () {
      this.scrollSubject$.next();
    },
    closeModal: function () {
      closeModalRoute(this);
    },
    onCloseReleaseDetails: function () {
      handleFromRoute(this, () => {
        this.$router.push({
          name: releasesListLDTRoutes.names.list,
        });
      });
    },
    onReleaseClicked: function (release) {
      //this.selectedClickedProduct = product;
      this.$router.push({
        name: releasesListLDTRoutes.names.tab,
        params: {
          release_id: release.release_id,
          tab: "overview",
        },
      });
    },

    onProductExportClicked: function () {
      openModalRoute(this, "product_export");
    },
    onFilterButtonClicked: function (searchType) {
      this.searchType = searchType;
      this.fetchListReset();
    },
    fetchListReset: function () {
      this.start = 0;
      this.loadedStart = 0;
      this.loadedEnd = false;
      this.fetchList();
    },
    fetchList: async function () {
      if (this.loadedEnd === false) {
        this.loadingFlag = true;

        const loadStatus = await this[ActionTypes.ReleaseList.FETCH.ALL](
          this.filter
        );
        if (loadStatus === LoadedEnd) {
          this.loadedEnd = true;
        }
        this.loadingFlag = false;
      }
    },
    fetchListNext: async function () {
      await this.fetchList();
      this.loadedStart = this.start;
    },
    onBeforeAdvancedSearchFetch: function () {
      this.searchString = "";
      //  this.barCodeCatalogError = false;
    },
    onAdvancedSearchCreateGroup: function () { },

    onExport: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "release_export",
        },
      });
    },

    onReleaseDelete: async function (item) {

      const confirmationResult = await confirmDelete(
        "Release",
        item.release_artist
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.ReleaseList.DELETE.SINGLE](item);
      }
    },
    onStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      const statusArray = this.statuses;

      const colorPropertyValue = payload.colorPropertyValue;

      const inactive_flag = statusArray.find(x => x.label_status_id == colorPropertyValue).inactive_flag;

      const selRelease = this.list.find(x => x.release_id == payload.itemID);

      if (inactive_flag && (inactive_flag == 1 || inactive_flag == '1')) {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "deactive_release",
            primary_key: payload.itemID,
            name: `${selRelease.release_title}-${selRelease.release_artist}`,
            status_id: colorPropertyValue,
            mode: 'deactivate'

          }
        });
      } else {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "deactive_release",
            primary_key: payload.itemID,
            name: `${selRelease.release_title}-${selRelease.release_artist}`,
            status_id: colorPropertyValue,
            mode: 'activate'

          }
        });
      }


      this[ActionTypes.ReleaseList.UPDATE.SINGLE](payload);
      console.log(statusArray, colorPropertyValue, inactive_flag, "::::::::::::::::::::::::::::::::::::::::::")
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }

  td.file_name a {}

  .dt-page--data-table {
    --offset: 135px;
  }

  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }

  .release-list-footer {
    border-top: 1px solid var(--sprt-5);
    padding: 0 10px;

    .status-list {
      .status {
        margin-top: 15px;
        max-width: 110px;
      }
    }
  }

  .dt-list-v2 {
    .dt-list--item {
      &:hover {
        //var(--icon-hover-color)
        background-color: green;
      }
    }
  }

  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
  //         border-radius: 30px;
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>